// extracted by mini-css-extract-plugin
export default {"meal_table":"Meal-listing_meal_table__M7MMo","plan_section":"Meal-listing_plan_section__9rjhP"};